import React, { Suspense, lazy } from 'react';
import {
  HashRouter as Router, Redirect, Switch, Route,
} from 'react-router-dom';
import Main from './layouts/Main'; // fallback for lazy pages
import './static/css/main.scss'; // All of our styles
// eslint-disable-next-line import/order
import ReactGA from 'react-ga4';

ReactGA.initialize('G-XMB3EZLQ4W'); // Replace with your tracking ID
ReactGA.send('pageview');
const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const Service = lazy(() => import('./pages/Service'));
const Teaching = lazy(() => import('./pages/Teaching'));

const App = () => (
  <Router basename={PUBLIC_URL}>
    <Suspense fallback={<Main />}>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route path="/about" component={About} />
        <Route path="/projects" component={Projects} />
        <Route path="/service" component={Service} />
        <Route path="/teaching" component={Teaching} />
        <Route path="/contact" component={Contact} />
        <Redirect exact from="/resume" to="/about" />
        <Route component={NotFound} status={404} />
      </Switch>
    </Suspense>
  </Router>
);

export default App;
